import React, { useState } from "react";
const emailUsername = process.env.REACT_APP_EMAIL_USERNAME;
const emailPassword = process.env.REACT_APP_EMAIL_PASSWORD;
const emailSecureToken = process.env.REACT_APP_SECURE_TOKEN;
const emailHost = process.env.REACT_APP_HOST;
const emailPort = process.env.REACT_APP_PORT;
const emailFrom = process.env.REACT_APP_FROM;
const emailTo = process.env.REACT_APP_TO;

const CareerForm = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    city: "",
    state: "",
    email: "",
    contactNumber: "",
    applyFor: "",
    experience: "",
    resume: null,
    message: "",
  });

  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    setFormData((prevFormData) => ({
      ...prevFormData,
      resume: selectedFile,
    }));
  };

  const readFileAsBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = () => {
        const base64String = reader.result.split(",")[1];
        resolve(base64String);
      };

      reader.onerror = (error) => {
        reject(error);
      };

      reader.readAsDataURL(file);
    });
  };
  const handleSubmit = async (e) => {
    try {
      e.preventDefault();

      if (!formData.resume) {
        // Handle the case where no resume file is selected
        console.log("Please select a resume file.");
        return;
      }
      const base64Data = await readFileAsBase64(formData.resume);

      const config = {
        Username: emailUsername,
        Password: emailPassword,
        SecureToken: emailSecureToken,
        Host: emailHost,
        Port: emailPort,
        From: emailFrom,
        To: emailTo,
        Subject: "QUICK SEO WEBSITE - Career Form details",
        Body: `
             Hi,
             <br />
             <br />
             These are candidate's career form details from Quick Seo Website.
             <br /> 
              <br />
              <strong>Name</strong> - ${formData.firstName} ${formData.lastName} 
              <br>
              <strong>City</strong> - ${formData.city} 
              <br>
              <strong>State</strong> - ${formData.state} 
              <br>
              <strong>Email</strong> - ${formData.email} 
              <br>
              <strong>Contact</strong> - ${formData.contactNumber}
              <br>
              <strong>Applied For</strong> - ${formData.applyFor} 
              <br>
              <strong>Experience</strong> - ${formData.experience}
              <br>
              <strong>Message</strong> - ${formData.message} 
              <br />
              <br />
              <br />
              Thank you
              <br />
              <br />
              <br />
              <strong>Please Find the Attachment below </strong>
                 `,
        Attachments: [
          {
            name: formData.resume.name,
            data: base64Data,
          },
        ],
      };

      if (window.Email) {
        window.Email.send(config)
          .then((message) => {
            console.log(message, "Message sent Successfully");

            // Reset form state
            document.getElementById("career-form").reset();

            setSuccessMessage(
              "Message received! We will get back to you soon."
            );
          })
          .catch((error) => {
            console.error("Error sending email:", error);
          });
      }
    } catch (error) {
      console.error("Error submitting form:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <form
        id="career-form"
        onSubmit={handleSubmit}
        className="job-form"
        encType="multipart/form-data"
        method="POST"
      >
        <div className="row">
          <div className="col-md-6 my-2">
            <input
              type="hidden"
              name="access_key"
              value="13d1939c-5872-47a3-ab8b-1654196cbe6b"
            />
            <input
              type="text"
              name="firstName"
              // value={formData.firstName}
              onChange={handleInputChange}
              placeholder="First Name"
              autoComplete="off"
              required
            />
          </div>
          <div className="col-md-6 my-2">
            <input
              type="text"
              name="lastName"
              // value={formData.lastName}
              onChange={handleInputChange}
              placeholder="Last Name"
              autoComplete="off"
              required
            />
          </div>
          <div className="col-md-6 my-2">
            <input
              type="text"
              name="city"
              // value={formData.city}
              onChange={handleInputChange}
              placeholder="City"
              autoComplete="off"
              required
            />
          </div>
          <div className="col-md-6 my-2">
            <input
              type="text"
              name="state"
              // value={formData.state}
              onChange={handleInputChange}
              placeholder="State"
              autoComplete="off"
              required
            />
          </div>
          <div className="col-md-6 my-2">
            <input
              type="email"
              name="email"
              // value={formData.email}
              onChange={handleInputChange}
              placeholder="Email Address"
              autoComplete="off"
              required
            />
          </div>
          <div className="col-md-6 my-2">
            <input
              type="tel"
              name="contactNumber"
              // value={formData.contactNumber}
              onChange={handleInputChange}
              placeholder="Contact Number"
              autoComplete="off"
              required
            />
          </div>
          <div className="col-6 my-2">
            <select
              name="applyFor"
              // value={formData.applyFor}
              onChange={handleInputChange}
              autoComplete="off"
              required
            >
              <option value="">-- Apply For --</option>
              <option value="seo">SEO</option>
              <option value="smo">SMO</option>
              <option value="ppc">PPC</option>
              <option value="contentWriter">Content Writer</option>
              <option value="businessAnalyst">Business Analyst</option>
            </select>
          </div>
          <div className="col-6 my-2">
            <select
              name="experience"
              // value={formData.experience}
              onChange={handleInputChange}
              required
            >
              <option value="">-- Select Experience --</option>
              <option value="1-2">1-2 Years</option>
              <option value="2-4">2-4 Years</option>
              <option value="4-6">4-6 Years</option>
              <option value="above6">Above 6 Years</option>
            </select>
          </div>
          <div className="col-12 my-2">
            <input
              type="file"
              name="file"
              id="resume"
              accept=".pdf, .docx, .doc"
              onChange={handleFileChange}
              placeholder="lalalaaa"
              title="select resume (pdf and docx files only)"
              required
            />
          </div>
          <div className="col-12 my-2">
            <textarea
              name="message"
              // value={formData.message}
              onChange={handleInputChange}
              placeholder="Message"
              autoComplete="off"
              required
            ></textarea>
          </div>
        </div>
        <div className="mx-auto d-flex justify-content-center">
          <button type="submit" className="career-apply-now" disabled={loading}>
            {loading ? "Submitting" : "Apply Now"}
          </button>
        </div>
        <div className="text-center">
          <center className="text-center py-3">
            {successMessage && <h6>{successMessage}</h6>}
          </center>
        </div>
      </form>
    </div>
  );
};

export default CareerForm;
